import { createI18n } from '@ahora-patagonia/i18n';
import { resources, defaultNS } from './resources.js';

/** Instancia del browser: detecta idioma por localStorage/navigator. */
export const i18n = createI18n({
  resources,
  defaultNS,
  fallbackLng: 'es',
  supportedLngs: ['es', 'en'],
  debug: (import.meta as any).env?.DEV === true,
});

/**
 * Instancia para SSR: sin detección (no hay `window`) e idioma fijo.
 * Una instancia nueva por request para no compartir estado entre requests.
 *
 * TODO(i18n): tomar el idioma del `Accept-Language` / prefijo de ruta cuando el portal
 * tenga más de un idioma.
 */
export function createServerI18n(lng = 'es') {
  return createI18n({
    resources,
    defaultNS,
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    detectLanguage: false,
    lng,
  });
}
